import { createSlice } from "@reduxjs/toolkit"

const KYCReminderModalSlice = createSlice({
  name: "kycReminderModalState",
  initialState: {
    open: false,
    type: "pending"
  },
  reducers: {
    setKYCReminderModalOpen: (state, action) => {
      state.open = action.payload
    },
    setKYCReminderModalType: (state, action) => {
      state.type = action.payload
    }
  }
})

export const { setKYCReminderModalOpen, setKYCReminderModalType } = KYCReminderModalSlice.actions

export default KYCReminderModalSlice.reducer
